/* eslint-disable react/display-name */
import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { reduxConnect } from '../../common';
import { DisplayAdWidget } from '../ads/displayAdWidget.jsx';
import { LazyLoadImg } from '../../common/utilities/lazyLoadImg';
import { convertUnixTimeStampToRelativeTime } from '../../common/utilities/dateTimeUtils';
import { DisplayAdUnit } from '../../containers/ads/displayAdUnitContainer';

const inlineAdSlotId = 'videos_inlineAd';
const inlineAdHeight = 250;
const inlineAdWidth = 300;
const isInfiniteScrollAd = true;

const mapStoreStateToProps = storeState => {
    const { videos } = storeState?.video;

    return { videos };
};

const mapDispatchToProps = {};

// TECHDEBT: Consider moving selectVideo into a synchronous redux action
export const ThumbnailList = reduxConnect( mapStoreStateToProps, mapDispatchToProps ) (memo(({ videos, selectVideo }) => {
    if (!videos || !selectVideo) {
        return null;
    }
    return videos?.map((video, index) => {
        let thumbTime = '';
        if (video?.puts) {
            // N.B currentVideoPublishDate timestamp is in seconds - required in Milliseconds.
            const currentVideoTimeStampInMilliSeconds = video.puts * 1000;
            thumbTime = convertUnixTimeStampToRelativeTime(currentVideoTimeStampInMilliSeconds) ?? '';
        }
        return (
            <Fragment key={`VIDEO-CONTAINER-${index}`}>
                <ThumbListItem key={video.i}>
                    <Anchor
                        href={video.plid}
                        onClick={() => {
                            selectVideo(video, videos, true);
                        }}>
                        <LazyLoadImg
                            alt=''
                            src={video.thumb}
                            style={featuredVideoImageStyle}
                        />
                        <ListitemInfoText>
                            <ThumbDescription>
                                {video.t}
                            </ThumbDescription>
                            <ThumbTime>{thumbTime}</ThumbTime>
                        </ListitemInfoText>
                    </Anchor>
                </ThumbListItem>

                {index > 0 && (index +1) % 7 === 0
                    && <ThumbListItem key={`CONSOLE-AD-${index}`}>
                        <DisplayAdUnit
                            slotId={inlineAdSlotId}
                            width={inlineAdWidth}
                            height={inlineAdHeight}
                            isInfiniteScrollAd={isInfiniteScrollAd}
                            infiniteScrollIndex={index} />
                    </ThumbListItem>
                }
            </Fragment>
        );
    });
}));

ThumbnailList.displayName = 'ThumbnailList';
ThumbnailList.propTypes = {
    videos: PropTypes.array,
    selectVideo: PropTypes.any
};

const featuredVideoImageStyle = {
    height: 168,
    width: '100%'
};

const ThumbListItem = styled.li`
    display: inline-block;
    height: 250px;
    width: 300px;
`;

const Anchor = styled.a`
    text-decoration: none;
`;

const ListitemInfoText = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 7px;
    background-color: #f9f9f9;
    color: #555555;
    font-size: 14px;
    padding: 12px 16px;
    height: 82px;
    width: 100%;
    margin: 0;
`;

const ThumbDescription = styled.h2`
    font: inherit;
    font-weight: 600;
    padding: 0;
    margin: 0;
`;

const ThumbTime = styled.span`
    font: inherit;
    font-weight: 200;
`;
